module.exports = __webpack_public_path__ + "static/IMG_2271-ef798d92ca3594e72df3c7602877f9ea.jpg";